import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpResponse,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { take, switchMap, tap } from 'rxjs/operators';
import { UserService } from 'services';
import { UserToken } from 'models';
import { environment } from 'environments/environment';

/**
 * Used to add Authorization Bearer Token to request
 */
@Injectable({
    providedIn: 'root'
})
export class UserInterceptor implements HttpInterceptor {
    //constructor(protected router: Router, protected userService: UserService) { }
    constructor(protected router: Router, private injector: Injector) { }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const userService = this.injector.get(UserService);
        return userService.userToken$.pipe(
            take(1),
            switchMap((userToken: UserToken) => {
                if ((req.url.match(new RegExp(`^${environment.origin}`)) && userToken) || (req.url.match(new RegExp(`^${environment.veritasUrl}`)) && userToken)) {
                    if (userToken.token) {
                        req = req.clone({
                            headers: req.headers.set('Authorization', 'Bearer ' + userToken.token)
                        });
                    }
                    if (userToken.claims && this.getControlledUserId(userToken)) {
                        req = req.clone({
                            headers: req.headers.set(
                                'Controlled-By',
                                this.getControlledUserId(userToken)
                            )
                        });
                    }
                }

                if (req.url.match(new RegExp(`^${environment.veritasUrl}`)) && userToken) {
                    if (userToken.claims ) {
                        req = req.clone({
                            headers: req.headers.set(
                                'x-userid', userToken.claims.nameid
                            )
                        });

                        req = req.clone({
                            headers: req.headers.set(
                                'x-environment', environment.veritasEnvironment
                            )
                        });
                    }
                }

                return next.handle(req);
            }),
            tap(
                (event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse) {
                        return event;
                    }
                },
                (error: any) => {
                    if (error instanceof HttpErrorResponse) {
                        // Logging out only if origin url is api
                        if (
                            req.url.match(new RegExp('^' + environment.origin)) &&
                            (error.status === 401 || error.status === 403)
                        ) {
                            userService.logout();
                        }
                    }
                }
            )
        );
    }

    /**
     * Extracting ControlledBy GUID from extended_claims
     *
     * @param userToken
     *
     * @return string | null
     */
    getControlledUserId(userToken: UserToken): string | null {
        if (!userToken || !userToken.claims || !userToken.claims.extended_claims) return;

        const controlledByClaim = /ControlledBy: /;
        const guid = /(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}/;

        const extendeClaimsString = Array.isArray(userToken.claims.extended_claims)
            ? userToken.claims.extended_claims.toString()
            : userToken.claims.extended_claims;

        if (controlledByClaim.test(extendeClaimsString)) {
            const guidMatch = extendeClaimsString.match(guid);
            return guidMatch && guidMatch[0] ? guidMatch[0] : null;
        } else return;
    }
}
